interface PrivacyElement {
  category: string;
  examples: string;
  collected: string;
}

export const privacyElements: PrivacyElement[] = [
  {
    category: 'Identifiers (A)',
    examples: 'Contact details, such as real name, alias, or email.',
    collected: 'YES',
  },
  {
    category: 'Identifiers (A)',
    examples:
      'Contact details, postal address, telephone or mobile contact number.',
    collected: 'NO',
  },
  {
    category:
      'Personal information categories listed in the California Customer Records statute',
    examples:
      'Education, employment, employment history, and financial information',
    collected: 'NO',
  },

  {
    category:
      'Protected classification characteristics under California or federal law',
    examples: 'Gender and date of birth',
    collected: 'NO',
  },

  {
    category: 'Commercial information',
    examples:
      'Transaction information, purchase history, financial details, and payment information',
    collected: 'NO',
  },

  {
    category: 'Biometric information',
    examples: 'Fingerprints and voiceprints',
    collected: 'NO',
  },

  {
    category: 'Internet or other similar network activity',
    examples:
      'Browsing history, search history, online behavior, interest data, and interactions other websites, applications, systems, and advertisements',
    collected: 'NO',
  },

  {
    category:
      'Audio, electronic, visual, thermal, olfactory, or similar information',
    examples:
      'Images and audio, video or call recordings created in connection with our business activities',
    collected: 'NO',
  },

  {
    category: 'Professional or employment-related information',
    examples:
      'Business contact details in order to provide you our Services at a business level or job title.',
    collected: 'YES',
  },

  {
    category: 'Education Information',
    examples: 'Student records and directory information',
    collected: 'NO',
  },

  {
    category: 'Inferences drawn from other personal information',
    examples:
      'Inferences drawn from any of the collected personal information listed above to create a profile or summary about, for example, an individual’s preferences and characteristics',
    collected: 'NO',
  },

  {
    category: 'Sensitive Personal Information',
    examples: '',
    collected: 'NO',
  },
];
